module["exports"] = [
  "خیابان",
  "کوچه",
  "بن بست",
  "بلوار"
];
